import React from 'react';
import { IconProps } from '../types';

const IcMenu = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='20' height='17' viewBox='0 0 20 17' fill='none' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.7471 2.19483H2.28882e-05V0H19.7471V2.19483ZM19.7471 9.32801L2.28882e-05 9.32801V7.13319L19.7471 7.13319V9.32801ZM2.28882e-05 16.4612L19.7471 16.4612V14.2664L2.28882e-05 14.2664V16.4612Z'
      fill={props?.fill ?? '#232F3E'}
    />
  </svg>
);

export default IcMenu;
